import { createSlice } from '@reduxjs/toolkit'
// import { attendancePolicy } from '../../reduxModels';

export type InitialState = {
    editData: any;
    refresh: boolean;
    isEdit: boolean;
    isView:boolean;
    create:boolean;
};

const initialState: InitialState = {
    editData:{},
    refresh:false,
    isEdit:false,
    isView:false,
    create:false,
}

const weekOffMasterSlice = createSlice({
    name: 'weekOffMaster',
    initialState,
    reducers: {
        setWeekOffMaster: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setWeekOffMaster } = weekOffMasterSlice.actions;
export default weekOffMasterSlice.reducer
